import { Container } from "react-bootstrap";
import React from "react";

export const Publications = () => {
    const publications = [
        {
            title: "‘I'm Done’: Describing Human Reactions to Successive Robot Failure",
            authors: "Shannon Liu, Maria Teresa Parreira, and Wendy Ju",
            conference: "Proceedings of the 2025 ACM/IEEE International Conference on Human-Robot Interaction (HRI ‘25). IEEE Press, 1458–1462",
            year: "2025"
        },
        {
            title: "Training Models to Detect Successive Robot Errors from Human Reactions",
            authors: "Shannon Liu, Maria Teresa Parreira, and Wendy Ju",
            conference: "arXiv",
            year: "2025",
            link: "https://arxiv.org/abs/2510.09080"
        }
    ];

    return (
        <section className="projects-section" id="publications" style={{ paddingTop: '100px', paddingBottom: '100px' }}>
            <Container>
                <h2 className="section-title text-center">Publications</h2>
                <div className="mt-5 d-flex flex-column gap-4">
                    {publications.map((pub, index) => (
                        <div className="project-card p-4" key={index} style={{ height: 'auto' }}>
                            <div className="project-content p-0">
                                <h3 className="mb-2">{pub.title}</h3>
                                <p className="mb-2" style={{ color: '#cfdffc', fontWeight: 500 }}>{pub.authors}</p>
                                <p className="mb-0" style={{ fontSize: '14px', color: '#90fff0' }}>
                                    {pub.conference}
                                    {pub.link && (
                                        <span> | <a href={pub.link} target="_blank" rel="noopener noreferrer" style={{ color: '#90fff0', textDecoration: 'underline' }}>View Paper</a></span>
                                    )}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
